var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleChromeSeeklogocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 435.8172 437.4605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6322a;}.cls-2{fill:#feda00;}.cls-3{fill:#65b54c;}.cls-4{fill:#60ac48;}.cls-5{fill:#fff;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:#f1cf00;}.cls-8{fill:#da3027;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 304.6655,
    y1: 339.9883,
    x2: 304.6655,
    y2: 495.8861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96c1e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#146cb5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.2041,199.7319s128.4775-5.7827,196.57,123.3374H294.2793s-39.1865-1.289-72.5918,46.2554c-9.6338,19.9155-19.9106,40.4727-8.3486,80.937-16.7027-28.26-88.6519-153.5293-88.6519-153.5293S175.4409,204.8687,305.2041,199.7319Z",
    transform: "translate(-87.8625 -199.6928)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M495.0859,527.5625s-59.247,114.1426-205.1181,108.5332C307.9629,604.9482,393.74,456.415,393.74,456.415s20.709-33.289-3.7441-85.9907c-12.4307-18.3047-25.09-37.4863-65.919-47.7134,32.836-.3256,177.2852.0205,177.2852.0205S555.53,412.6226,495.0859,527.5625Z",
    transform: "translate(-87.8625 -199.6928)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.2354,528.4307s-69.2227-108.3936,8.5795-231.9078c17.98,31.16,103.7105,179.72,103.7105,179.72s18.4692,34.5781,76.3408,39.7558c22.0606-1.6094,45.0068-2.9824,74.28-33.2226-16.1387,28.5937-88.6729,153.5205-88.6729,153.5205S185.5439,638.2529,116.2354,528.4307Z",
    transform: "translate(-87.8625 -199.6928)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.9678,637.1533l29.1855-121.792s32.0918-2.5049,58.9834-32.0166C361.4434,512.709,289.9678,637.1533,289.9678,637.1533Z",
    transform: "translate(-87.8625 -199.6928)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.4531,419.7856a97.2144,97.2144,0,1,1,97.2149,97.2183A97.2118,97.2118,0,0,1,207.4531,419.7856Z",
    transform: "translate(-87.8625 -199.6928)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.7227,419.7856a80.9429,80.9429,0,1,1,80.9453,80.9449A80.9419,80.9419,0,0,1,223.7227,419.7856Z",
    transform: "translate(-87.8625 -199.6928)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M501.3623,322.7314,381.1807,357.9688s-18.1231-26.5958-57.1036-35.2579C357.8516,322.5957,501.3623,322.7314,501.3623,322.7314Z",
    transform: "translate(-87.8625 -199.6928)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M211,445.89c-16.89-29.2495-86.31-149.16-86.31-149.16l89.03,88.07s-9.15,18.82-5.68,45.7Z",
    transform: "translate(-87.8625 -199.6928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChromeSeeklogocom);
export default __webpack_public_path__ + "static/media/google-chrome-seeklogo.com.e34f6bb8a8282a0f592d138c0380c88f.svg";
export { ForwardRef as ReactComponent };